<template src='./index.html'></template>
<script>
import { getdata } from './data.js';
import minhead from '@/components/common/minHead/index.vue';
import {
  sjclzx_sgcl_pz_query,
  sjclzx_sgcl_fp_query,
  sjclzx_sgcl_saveProcessResults
} from "../../../../api/sjclzx_iinv.js";

export default {
    name: 'iinv_sjclzx_sgcl',
    props: {
      params: {
        default: {}
      }
    },
    components: {
        minhead
    },
    data: function() {
        return {
          initFlag: true,
          //凭证数据
          pz_headData: getdata().pz_headData,
          pz_searchlist: getdata().pz_searchlist,
          pz_searchdata: getdata().pz_searchdata,
          pz_pagination: getdata().pz_pagination,
          pz_shaidiag: false,
          pz_outlist: [],
          pz_searchdiag: false,
          pz_tableData: [],
          ys_pz_tableData: [],
          pz_tablekey: 0,
          pz_overlength: 0,
          pz_sort: "",
          pz_order: "",
          //发票数据
          fp_headData: getdata().fp_headData,
          fp_searchlist: getdata().fp_searchlist,
          fp_searchdata: getdata().fp_searchdata,
          fp_pagination: getdata().fp_pagination,
          fp_shaidiag: false,
          fp_outlist: [],
          fp_searchdiag: false,
          fp_tableData: [],
          ys_fp_tableData: [],
          fp_tablekey: 0,
          fp_overlength: 0,
          fp_sort: "",
          fp_order: "",
          // 业务类型处理结果
          pz_jg_headData: getdata().pz_jg_headData,
          pz_jg_tableData: [],
          fp_jg_headData: getdata().fp_jg_headData,
          fp_jg_tableData: [],
          pz_jg_total: 0,
          fp_jg_total: 0,
        };
    },
    mounted() {
    },
    created() {
      if (this.params.voucherNos && this.params.voucherNos.length === 1) {
        // 如果是通过凭证维度进入,凭证模块只展示点击进来的这条数据,且将该凭证号写入上方的查询条件
        this.pz_searchdata.voucherNo = this.params.voucherNos[0];
        this.pz_searchdata = JSON.parse(JSON.stringify(this.pz_searchdata));
      }
      if (this.params.kaiprqs && this.params.kaiprqs.length > 0) {
        // 开票日期条件默认为该凭证记账日期所属的月份1-31日
        this.fp_searchdata.kaiprq = this.params.kaiprqs;
        this.fp_searchdata = JSON.parse(JSON.stringify(this.fp_searchdata));
      }
      if (this.params.faphms && this.params.faphms.length === 1) {
        // 如果是通过发票维度进入,发票模块只展示点击进来的这条数据,且将该发票号码写入上方的查询条件
        this.fp_searchdata.faphm = this.params.faphms[0];
        this.fp_searchdata = JSON.parse(JSON.stringify(this.fp_searchdata));
      }
      if (this.params.postingDates && this.params.postingDates.length > 0) {
        // 记账日期条件默认为该发票开票日期所属的月份1-31日
        this.pz_searchdata.postingDate = this.params.postingDates;
        this.pz_searchdata = JSON.parse(JSON.stringify(this.pz_searchdata));
      }
      this.getPz_data();
      this.getFp_data();
      this.initFlag = false;
    },
    methods: {
      // 凭证接口开始
      pz_closeshaidiag() {
        this.pz_shaidiag = false;
      },
      pz_confirmfilter(e) {
        this.pz_headData = e.chooselist;
        this.pz_outlist = e.nochooselist;
        this.pz_shaidiag = false;
      },
      pz_forUpdateSearch() {
        this.pz_searchdiag = true;
      },
      pz_submitSearch() {
        this.pz_pagination.pageNum = 1;
        this.pz_pagination.paginationkey++;
        this.getPz_data();
      },
      pz_geOoverLength(e) {
        this.pz_overlength = e;
      },
      pz_sizechange(e) {
        this.pz_pagination.pageSize = e;
        this.getPz_data();
      },
      pz_currentChange(e) {
        this.pz_pagination.pageNum = e;
        this.getPz_data();
      },
      getPz_data() {
        let params = JSON.parse(JSON.stringify(this.pz_searchdata));
        params.companyCode = this.params.companyCode;
        if (this.initFlag) {
          params.voucherNoList = this.params.voucherNos;
        }
        params.current = this.pz_pagination.pageNum
        params.size = this.pz_pagination.pageSize
        params.sort = this.pz_sort
        params.order = this.pz_order
        sjclzx_sgcl_pz_query(params).then((res) => {
          if (res.data.code !== 1) {
            this.$message.error(res.data.msg);
            return;
          }
          this.pz_pagination.total = res.data.data.total;
          this.pz_pagination.paginationkey++;
          this.pz_tableData = res.data.data.records;
          // 过滤处理结果中的数据（已勾选）
          for (let i = 0; i < this.pz_jg_tableData.length; i++) {
            this.pz_tableData = this.pz_tableData.filter(item => item.id !== this.pz_jg_tableData[i].id);
          }
          this.ys_pz_tableData = res.data.data.records;
        });
      },
      pz_selectionChange(rows) {
        for (let i = 0; i < rows.length; i++) {
          this.pz_jg_tableData.push(rows[i]);
          this.pz_tableData = this.pz_tableData.filter(item => item.id !== rows[i].id);
        }
        this.fp_jg_count();
      },
      pz_sortchange(data) {
        this.pz_sort = data.prop
        this.pz_order = data.order === "ascending" ? 'asc' : 'desc'
        this.getPz_data();
      },
      // 凭证接口结束
      // 发票接口开始
      fp_closeshaidiag() {
        this.fp_shaidiag = false;
      },
      fp_confirmfilter(e) {
        this.fp_headData = e.chooselist;
        this.fp_outlist = e.nochooselist;
        this.fp_shaidiag = false;
      },
      fp_forUpdateSearch() {
        this.fp_searchdiag = true;
      },
      fp_submitSearch() {
        this.fp_pagination.pageNum = 1;
        this.fp_pagination.paginationkey++;
        this.getFp_data();
      },
      fp_geOoverLength(e) {
        this.fp_overlength = e;
      },
      fp_sizechange(e) {
        this.fp_pagination.pageSize = e;
        this.getFp_data();
      },
      fp_currentChange(e) {
        this.fp_pagination.pageNum = e;
        this.getFp_data();
      },
      getFp_data() {
        let params = JSON.parse(JSON.stringify(this.fp_searchdata));
        params.companyCode = this.params.companyCode;
        if (this.initFlag) {
          params.faphmList = this.params.faphms;
        }
        params.current = this.fp_pagination.pageNum
        params.size = this.fp_pagination.pageSize
        params.sort = this.fp_sort
        params.order = this.fp_order
        sjclzx_sgcl_fp_query(params).then((res) => {
          if (res.data.code !== 1) {
            this.$message.error(res.data.msg);
            return;
          }
          this.fp_pagination.total = res.data.data.total;
          this.fp_pagination.paginationkey++;
          this.fp_tableData = res.data.data.records;
          // 过滤处理结果中的数据（已勾选）
          for (let i = 0; i < this.fp_jg_tableData.length; i++) {
            this.fp_tableData = this.fp_tableData.filter(item => item.id !== this.pz_jg_tableData[i].id);
          }
          this.ys_fp_tableData = res.data.data.records;
        });
      },
      fp_selectionChange(rows) {
        for (let i = 0; i < rows.length; i++) {
          this.fp_jg_tableData.push(rows[i]);
          this.fp_tableData = this.fp_tableData.filter(item => item.id !== rows[i].id);
        }
        this.fp_jg_count();
      },
      fp_sortchange(data) {
        this.fp_sort = data.prop
        this.fp_order = data.order === "ascending" ? 'asc' : 'desc'
        this.getFp_data();
      },
      // 发票接口结束
      // 业务类型处理结果接口开始
      pz_jg_delete(row) {
        this.pz_tableData.push(row);
        this.pz_jg_tableData = this.pz_jg_tableData.filter(item => item.id !== row.id);
        this.fp_jg_count();
      },
      fp_jg_delete(row) {
        this.fp_tableData.push(row);
        this.fp_jg_tableData = this.fp_jg_tableData.filter(item => item.id !== row.id);
        this.fp_jg_count();
      },
      fp_jg_count() {
        let pz_jg_total = 0;
        let fp_jg_total = 0;
        for (let i = 0; i < this.pz_jg_tableData.length; i++) {
          pz_jg_total += this.pz_jg_tableData[i].localAmount;
        }
        for (let i = 0; i < this.fp_jg_tableData.length; i++) {
          fp_jg_total += parseFloat(this.fp_jg_tableData[i].shuiehj);
        }
        this.pz_jg_total = pz_jg_total;
        this.fp_jg_total = fp_jg_total;
      },
      resultReset() {
        this.pz_tableData = this.ys_pz_tableData;
        this.fp_tableData = this.ys_fp_tableData;
        this.pz_jg_tableData = [];
        this.fp_jg_tableData = [];
        this.pz_jg_total = 0;
        this.fp_jg_total = 0;
      },
      saveProcessResults(type) {
        if (this.pz_jg_tableData.length === 0) {
          this.$message.error("请勾选凭证数据！");
          return;
        }
        if (this.fp_jg_tableData.length === 0) {
          this.$message.error("请勾选发票数据！");
          return;
        }
        let title = "票账有差提示";
        if(type === '1') {
          title = "票账相符提示";
        }
        if (this.pz_jg_total - this.fp_jg_total >= 0) {
          this.$confirm('请确认是否执行<br>凭证总记账金额：' + this.toThousands(this.pz_jg_total) + '<br>发票总税额：' + this.toThousands(this.fp_jg_total) + '<br>差额：' + '<span style="color: red">' + this.toThousands(this.pz_jg_total - this.fp_jg_total) + '</span>', title, {
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.saveProcessResultsNoCheck(type);
          })
        } else {
          this.saveProcessResultsNoCheck(type);
        }
      },
      saveProcessResultsNoCheck(type) {
        let voucherIds = [];
        for (let i = 0; i < this.pz_jg_tableData.length; i++) {
          voucherIds.push(this.pz_jg_tableData[i].id);
        }
        let invoiceIds = [];
        for (let i = 0; i < this.fp_jg_tableData.length; i++) {
          invoiceIds.push(this.fp_jg_tableData[i].id);
        }
        sjclzx_sgcl_saveProcessResults({voucherIds: voucherIds, invoiceIds: invoiceIds, type: type}).then((res) => {
          if (res.data.code !== 1) {
            this.$message.error(res.data.msg);
            return;
          }
          this.$message.success(res.data.msg);
          this.forback();
        });
      },
      // 业务类型处理结果接口结束
      // 返回主页面
      forback() {
        this.$emit('forback');
      }
    }
};
</script>

<style scoped lang='less'>
@import url('./index.less');
</style>
